// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile___86_1"};